export const textOperators = [
  { name: '=', value: '=', label: '=' },
  { name: '!=', value: '!=', label: '!=' },
  { name: 'contains', value: 'contains', label: 'contient' },
  { name: 'beginsWith', value: 'beginsWith', label: 'commence par' },
  { name: 'endsWith', value: 'endsWith', label: 'finit par' },
  { name: 'doesNotContain', value: 'doesNotContain', label: 'ne contient pas' },
  { name: 'doesNotBeginWith', value: 'doesNotBeginWith', label: 'ne commence pas par' },
  { name: 'doesNotEndWith', value: 'doesNotEndWith', label: 'ne finit pas par' }
]

export const equalityOperators = [
  { name: '=', value: '=', label: '=' },
  { name: '!=', value: '!=', label: '!=' }
]

export const multiselectOperators = [
  { name: 'in', value: 'in', label: 'dans' },
  { name: 'notIn', value: 'notIn', label: "n'est pas dans" }
]

export const dateOperators = [
  { name: '=', value: '=', label: '=' },
  { name: '!=', value: '!=', label: '!=' },
  { name: '<', value: '<', label: '<' },
  { name: '>', value: '>', label: '>' },
  { name: '<=', value: '<=', label: '<=' },
  { name: '>=', value: '>=', label: '>=' },
  { name: 'between', value: 'between', label: 'entre' },
  { name: 'notBetween', value: 'notBetween', label: "n'est pas entre" }
]
